import { V7EmilyCarWashAfter, V7EmilyWakeUpAfter } from './V7';
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { images } from "./images";
import { doDoorKnock, doWaitImageByTime } from '../helpers/helpers';
import Question from '../../src/shell/Questions';

export const V7EmilyWakeUp = async (): Promise<any> => {
    doWaitImageByTime(images.v1.Room2);
    doDoorKnock();
    doWaitImageByTime(images.v7.EmilyMorningWakeup_1);
    emily.talk(`Good morning!`);
    mc.talk(`Morning.`);

    ImageClass.setImage(images.v7.EmilyMorningWakeup_3);
    emily.talk(`You've always been a late sleeper, haha.`);

    if (Game.seenScenarios.includes(`V6VanessaCustomerMeeting`)) {
        emily.talk(`I just wanted to let you know that you have a visitor.`);
        mc.talk(`Really? Who is it?`);
        emily.talk(`Vanessa.`);
        // TODO: natual expression
        mc.talk(`It's became her habit coming here in the morning.`);
        emily.talk(`Is Joey ok with that?`);
        if (Question.globalAnswers.v6EmilyAfterJoeRivalConvAllowDatingJoe) {
            mc.talk(`Mmm... Is she okay with you seeing Joey?`);
            ImageClass.setImage(images.v7.EmilyMorningWakeup_5.partials.EmilyMorningWakeup_5_p_2, { putParent: true });
            emily.talk(`Hey... I told you, we just went for dinner, it was innocent.`);
            ImageClass.setImage(images.v7.EmilyMorningWakeup_5.partials.EmilyMorningWakeup_5_p);
            mc.talk(`I don't think he sees it that way.`);
            ImageClass.setImage(images.v7.EmilyMorningWakeup_5);
            emily.talk(`We'll have to see...`);
            ImageClass.setImage(images.v7.EmilyMorningWakeup_5.partials.EmilyMorningWakeup_5_p);
            mc.talk(`Anyway, I don't think he'd care either way.`);

        } else {
            mc.talk(`Even if he isn't, I don't think she cares.`);
        }
        mc.talk(`What is she doing here?`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_4);
        emily.talk(`I have no idea, she's your problem now haha.`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_5);
        emily.talk(`I'm going out for some errands. I'll be back later.`);
    } else {
        ImageClass.setImage(images.v7.EmilyMorningWakeup_5);
        emily.talk(`I wanted to let you know that I'm going out for some errands, I'll be back later.`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_3);
        mc.talk(`You woke me up for that?`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_4);
        emily.talk(`Hey! I didn't know you were still asleep.`);
        mc.talk(`Well... I'm up now.`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_5);
        emily.talk(`Good! Do something with your life.`);
        mc.talk(`Hey...`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_3);
        emily.talk(`Haha, I'm just joking!`);
        ImageClass.setImage(images.v7.EmilyMorningWakeup_5);
        emily.talk(`Anyway, enjoy the rest of the day. I'll catch up with you later!`);
        // emily.talk(`She said her name is Vanessa.`);
        // ImageClass.setImage(images.v7.EmilyMorningWakeup_4);
        // emily.talk(`Isn't that Joey's girlfriend?`);
        // mc.talk(`Yeah, she is.`);
        // ImageClass.setImage(images.v7.EmilyMorningWakeup_5);
        // emily.talk(`So what is she doing here?`);
        // mc.talk(`I have no idea... I guess it's time to find out.`);
    }
    return jump(V7EmilyWakeUpAfter, "V7EmilyWakeUpAfter");
};